"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.TourDetails = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var mapStateToProps = function mapStateToProps(state) {
  var _state$systemExchange;

  return {
    user: state.user,
    linkedPortals: state.informationLists.linkedPortals,
    projects: (_state$systemExchange = state.systemExchange) === null || _state$systemExchange === void 0 ? void 0 : _state$systemExchange.projects,
    portals: state.portals,
    activePortal: state.activePortal
  };
};

exports.mapStateToProps = mapStateToProps;
var actionCreators = {
  loadSystemExchangeData: _nicbaseReducers.findSystemExchangeProjects
};

var TourDetails = function TourDetails(_ref) {
  var _tour$customerPortalI, _tour$invoiceInfo, _tour$invoiceInfo2, _tour$invoiceInfo3, _tour$invoiceInfo4;

  var hasPermissions = _ref.hasPermissions,
      tour = _ref.tour,
      user = _ref.user,
      linkedPortals = _ref.linkedPortals,
      projects = _ref.projects,
      loadSystemExchangeData = _ref.loadSystemExchangeData,
      activePortal = _ref.activePortal,
      portals = _ref.portals;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  (0, _react.useEffect)(function () {
    if (hasPermissions(['module.dcc.systemexchange.read'])) {
      loadSystemExchangeData(portalId);
    }
  }, [loadSystemExchangeData, portalId, hasPermissions]);
  var _tour$projects = tour.projects,
      tourProjects = _tour$projects === void 0 ? [] : _tour$projects;
  var customerPortals = [];
  (_tour$customerPortalI = tour.customerPortalIds) === null || _tour$customerPortalI === void 0 ? void 0 : _tour$customerPortalI.forEach(function (id, index) {
    var portal; // check if its is my own portal

    if (parseInt(id, 10) === parseInt(activePortal, 10)) {
      portal = portals[id];
    } else {
      // if not, it must be from a linked portal
      portal = linkedPortals[id];
    }

    if (portal) {
      customerPortals.push( /*#__PURE__*/_react["default"].createElement("span", null, portal.name, index !== tour.customerPortalIds.length - 1 ? ', ' : ' '));
    }

    return null;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0 px-1 pb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourName"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, tour.name)), tour.externalId && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.externalId"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, tour.externalId)), tour.id && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourId"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, tour.id)), tour.createdAt && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.createdAt"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.createdAt,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), tour.earliestStartTime && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.earliestStart"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: tour.earliestStartTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), ((_tour$invoiceInfo = tour.invoiceInfo) === null || _tour$invoiceInfo === void 0 ? void 0 : _tour$invoiceInfo.reference) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.invoice.reference"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, (_tour$invoiceInfo2 = tour.invoiceInfo) === null || _tour$invoiceInfo2 === void 0 ? void 0 : _tour$invoiceInfo2.reference)), ((_tour$invoiceInfo3 = tour.invoiceInfo) === null || _tour$invoiceInfo3 === void 0 ? void 0 : _tour$invoiceInfo3.disableTemperatures) !== undefined && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.invoice.tourType"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.invoice.tourType.".concat((_tour$invoiceInfo4 = tour.invoiceInfo) !== null && _tour$invoiceInfo4 !== void 0 && _tour$invoiceInfo4.disableTemperatures ? 'tempRelevant' : 'tempNotRelevant')
  }))), tour.status && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.status"
  }), ":"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.status.".concat(tour.status)
  }))), tourProjects.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.projectForTour"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, tourProjects.map(function (project) {
    var _ref2 = projects.find(function (iteratedProject) {
      return iteratedProject.id.toString() === project.id;
    }) || {},
        projectName = _ref2.projectName;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: project.id,
      className: "flex mb-1 mr-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "underline"
    }, projectName), (project === null || project === void 0 ? void 0 : project.tourProperties) && Object.entries(project.tourProperties).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];

      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-bold mr-1"
      }, key, ":"), value);
    })));
  }))), tour.additionalData && Object.keys(tour.additionalData).length && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, Object.keys(tour.additionalData).map(function (key) {
    if (_typeof(tour.additionalData[key]) !== 'object' && !Array.isArray(tour.additionalData[key])) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-bold mr-1"
      }, key, ":"), tour.additionalData[key]);
    }

    return null;
  })), tour.customerPortalIds && tour.customerPortalIds.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold mr-1"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.headers.customerPortalIds"
  }), ":"), customerPortals) : null);
};

exports.TourDetails = TourDetails;
TourDetails.propTypes = {
  hasPermissions: _propTypes["default"].func.isRequired,
  tour: _propTypes["default"].shape({
    appLicensePlate: _propTypes["default"].string,
    id: _propTypes["default"].string,
    status: _propTypes["default"].string,
    externalId: _propTypes["default"].string,
    customerPortalIds: _propTypes["default"].arrayOf({}),
    serviceProviderPortalId: _propTypes["default"].number,
    name: _propTypes["default"].string,
    earliestStartTime: _propTypes["default"].string,
    scheduledStartTime: _propTypes["default"].string,
    scheduledEndTime: _propTypes["default"].string,
    createdAt: _propTypes["default"].instanceOf(Date),
    sharedWithPortals: _propTypes["default"].arrayOf({}),
    additionalData: _propTypes["default"].arrayOf({}),
    projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].string,
      tourProperties: _propTypes["default"].shape({})
    })),
    dataRequest: _propTypes["default"].shape({
      haulerPortalId: _propTypes["default"].number,
      haulerEmail: _propTypes["default"].string
    }),
    invoiceInfo: _propTypes["default"].shape({
      reference: _propTypes["default"].string,
      disableTemperatures: _propTypes["default"].bool
    })
  }).isRequired,
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }).isRequired,
  linkedPortals: _propTypes["default"].shape().isRequired,
  projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    projectName: _propTypes["default"].string,
    endpointId: _propTypes["default"].number,
    sharedData: _propTypes["default"].arrayOf(_propTypes["default"].string)
  })),
  loadSystemExchangeData: _propTypes["default"].func,
  activePortal: _propTypes["default"].number.isRequired,
  portals: _propTypes["default"].instanceOf(Object).isRequired
};

var noop = function noop() {};

TourDetails.defaultProps = {
  projects: [],
  loadSystemExchangeData: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(null)((0, _reactRedux.connect)(mapStateToProps, actionCreators)(TourDetails));

exports["default"] = _default;